import React from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Popover from '@material-ui/core/Popover';

import AppsSwitcher from './AppsSwitcher';
import * as userSelectors from '../../selectors/userSelectors';
import { Tooltip } from '@material-ui/core';

class AppsDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
        this.apps = React.createRef();
    }

    onPopoverToggle = () => {
        this.setState(state => ({ open: !state.open }));
    };

    onPopoverClose = () => {
        this.setState({ open: false });
    };

    render() {
        const { currentUser, classes } = this.props;

        if (!currentUser) {
            return null;
        }

        let arrowIconSrc = this.state.open
            ? '/assets/arrowUp.svg'
            : '/assets/arrowDown.svg';

        return (
            <React.Fragment>
                <Tooltip title="Switch to...">
                    <div
                        ref={this.apps}
                        onClick={this.onPopoverToggle}
                        className={classes.appsButton}
                    >
                        <img
                            src="/assets/apps.svg"
                            alt="apps-icon"
                            className={classes.appsButtonIcon}
                        />
                        <span className={classes.appsButtonText}>Apps</span>
                        <img
                            src={arrowIconSrc}
                            alt="arrow-icon"
                            className={classes.arrowIcon}
                        />
                    </div>
                </Tooltip>
                <Popover
                    open={this.state.open}
                    onClose={this.onPopoverClose}
                    anchorEl={this.apps.current}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <React.Fragment>
                        <div className={classes.wrapper}>
                            <div className={classes.switcherText}>
                                Switch apps...
                            </div>
                            <AppsSwitcher
                                onClosePopover={this.onPopoverClose}
                            />
                        </div>
                    </React.Fragment>
                </Popover>
            </React.Fragment>
        );
    }
}

AppsDropdown.propTypes = {
    currentUser: PropTypes.object,
};

AppsDropdown.defaultProps = {
    currentUser: undefined,
};

const mapStateToProps = state => ({
    currentUser: userSelectors.getCurrentUser(state),
});

const style = ({ spacing, palette }) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        justifyContent: 'space-between',
        minWidth: 210,
    },
    appsButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minWidth: 110,
        height: 36,
        borderRadius: '6px',
        backgroundColor: palette.background.gray1Color,
        border: `1px solid ${palette.border.main}`,
        paddingLeft: spacing.unit,
        paddingRight: spacing.unit,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: palette.background.gray2Color,
        },
    },
    appsButtonIcon: {
        height: 14,
        width: 14,
        paddingTop: 3,
        paddingLeft: spacing.unit - 3,
    },
    appsButtonText: {
        color: palette.text.secondary,
        fontSize: 14,
    },
    switcherText: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: spacing.unit * 2,
        color: palette.text.secondary,
        fontWeight: 'bold',
        fontSize: 14,
        height: 48,
    },
    arrowIcon: {
        color: palette.text.secondary,
    },
});

export default connect(mapStateToProps)(injectSheet(style)(AppsDropdown));



// WEBPACK FOOTER //
// ./src/containers/appsDropdown/AppsDropdown.js